module.exports = __webpack_public_path__ + "static/media/tezos-sym.b5be31f6.svg";